import { cn } from '../../lib/utils';

/**
 * Pine Group 공통 버튼 컴포넌트
 *
 * variant: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger'
 * size:    'sm' | 'md' | 'lg'
 */
const variants = {
  primary:   'bg-pine-900 text-white hover:bg-pine-700 active:bg-pine-800 dark:bg-accent-600 dark:hover:bg-accent-500',
  secondary: 'bg-[var(--bg-subtle)] text-[var(--text)] hover:bg-[var(--border)] dark:bg-pine-800 dark:hover:bg-pine-700',
  outline:   'border border-[var(--border)] text-[var(--text)] hover:bg-[var(--bg-subtle)] dark:border-pine-600 dark:hover:bg-pine-800',
  ghost:     'text-[var(--text)] hover:bg-[var(--bg-subtle)] dark:hover:bg-pine-800',
  danger:    'bg-danger text-white hover:bg-danger-dark active:bg-red-800',
};

const sizes = {
  sm: 'h-7 px-3 text-xs gap-1',
  md: 'h-9 px-4 text-sm gap-1.5',
  lg: 'h-11 px-5 text-base gap-2',
};

export function Button({
  variant = 'primary',
  size = 'md',
  className,
  disabled,
  children,
  ...props
}) {
  return (
    <button
      className={cn(
        // 기본
        'inline-flex items-center justify-center font-medium rounded-md',
        'transition-colors duration-150 select-none',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-400 focus-visible:ring-offset-1',
        // 비활성
        disabled && 'opacity-40 cursor-not-allowed pointer-events-none',
        // variant / size
        variants[variant],
        sizes[size],
        className,
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
